import React from 'react';
import { useDispatch } from 'react-redux';
//assets
import { CancelIcon } from "pages/Quotes/assets/imagesSVG";
//interface
import { BlockedItemProps, MessageProps } from './interface';
//components
import toast from "components/Toast/dispatch";
import blockedItemToast from "components/BlockedItemToast/dispatch";
import oneActionToast from "pages/Quotes/components/generics/Toast/OneActionToast/dispatch";
//utils
import { DisableButton } from 'utils/DisableButton';

const BlockedItem: React.FC<BlockedItemProps> = (props) => {
  const {
    stock,
    item,
    disabled,
    customProps,
    setShouldReset,
    getProductStatus,
    distributionCenter,
    quotesDetailsStore
  } = props;

  const dispatch = useDispatch();
 
  const messageBlockedItem = (message?: string) => `<p class='text-styles text-center'>Item bloqueado:<br /><b class='color-alert fs-2'>${message}</b></p>`;
  const tooltipTextRule = distributionCenter === "LAJ" ? messageBlockedItem("Não é possível salvar orçamentos com CD de Lajeado") : 
  item?.isBlockedItem ? messageBlockedItem(item?.blockedItemDescription) : messageBlockedItem("Clique para mais informações");

  const blockedRuleNumber = (stock: any) => {
    return (
      <span>Trava comercial {item?.isBlockedItem ? item?.blockedItemDescription : stock.blockMessage}</span>
    );
  };

  return (
    <CancelIcon
      disabled={disabled}
      dataTestId="cancelIcon"
      tooltip={tooltipTextRule ?? undefined}
      className={`btnEdit mr-3 ${DisableButton(disabled)}`}
      onClick={() => {
        !disabled &&
          getProductStatus(
            distributionCenter,
            item.supplierProductcode,
            item.message ?? '',
            quotesDetailsStore?.customerCode || ""
          ).then((itemData: MessageProps) => {
            blockedItemToast.blockedItem(
              `${itemData.message}\n Solicite à coordenação a liberação \n temporária do item para poder gravar. \n\n\n Caso o item já tenha sido liberado para gravação, \n clique no botão abaixo.`,
              "Se preferir, continue cotando os demais \n itens e tente novamente mais tarde.",
              () => {
                setShouldReset(true);
                getProductStatus(
                  distributionCenter,
                  item.supplierProductcode,
                  item.message ?? '',
                  quotesDetailsStore?.customerCode || ""
                ).then((itemData: MessageProps) => {
                  if (itemData.blocked) {
                    oneActionToast.warning("Item bloqueado para gravação neste cliente. É necessária a liberação da coordenação para desbloquear a gravação.");
                    dispatch({ type: "CLOSE_BLOCKED_ITEM_TOAST" });
                  } else {
                    getProductStatus(
                      distributionCenter,
                      item.supplierProductcode,
                      item.message ?? '',
                      quotesDetailsStore?.customerCode || ""
                    ).then((result: MessageProps) => {
                      customProps?.getDetail(item.sequenceNumber, result.blocked);
                      toast.success("Item atualizado com sucesso!");
                      dispatch({ type: "CLOSE_BLOCKED_ITEM_TOAST" });
                    });
                  }
                });
              },
              "Tentar novamente",
              "Continuar cotação",
              blockedRuleNumber(stock)
            );
          });
      }}
    />
  );
};

export default BlockedItem;